<template>
  <div class="ui container">
    <div class="ui top attached tabular menu">
      <div v-for="(obs, index) in observationsDetail" :key="index">
        <a
          v-if="obs.observation.procedure != null"
          class="item active"
          :data-tab="index"
        >{{"Variable " + (index + 1)}}</a>
      </div>
    </div>
    <div v-for="(obs, index) in observationsDetail" :key="index">
      <div class="ui bottom attached tabular segment active" :data-tab="index">
        <div v-if="obs.observation.procedure.dataProduction != null">
          <div
            class="sensor-panel"
            v-if="obs.observation.procedure.dataProduction.sensors != null"
          >
            <div
              v-for="(sensor, index) in obs.observation.procedure.dataProduction.sensors"
              :key="index"
            >
              <div class="ui segment">
                <div class="ui top left attached label" v-if="sensor.model != null">{{sensor.model}}</div>
                <div class="ui top left attached label" v-else>{{sensor.name}}</div>
                <div v-if="sensor.manufacturer != null">Manufacturer : {{sensor.manufacturer}}</div>
                <div v-if="sensor.serialNumber != null">Serial number : {{sensor.serialNumber}}</div>
                <div v-if="sensor.sensorType != null">Sensor type : {{getI18n(sensor.sensorType, "en")}}</div>
                <div v-if="sensor.documents !=null">
                  <div v-for="(document, index) in sensor.documents" :key="index">
                    <div>
                      {{document.type}} -
                      <a :href="getI18n(document, 'en')"></a>
                    </div>
                  </div>
                </div>
                <div
                  v-if="sensor.calibration != null"
                >Calibration : {{getI18n(sensor.calibration,"en")}}</div>
                <div v-if="sensor.activityPeriods != null">
                  <div v-for="(activityPeriod, index) in sensor.activityPeriods" :key="index">
                    <div>From {{activityPeriod.dateBeg}} to {{activityPeriod.dateEnd}}</div>
                  </div>
                </div>
                <div
                  v-if="sensor.parametrisationDescription != null"
                >Parametrisation description : {{getI18n(sensor.parametrisationDescription, "en")}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.sensor-panel {
  position: relative;
  height: 200px;
  overflow: auto;
}

.lineage-panel {
  position: relative;
  height: 200px;
  overflow: auto;
}
</style>

<script>
export default {
  props: ["observationsDetail"],
  methods: {
    /**
     * getters
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    }
  }
};
</script>

